import { render } from "./JurisdictionManagementIcon.vue?vue&type=template&id=0edd095e&ts=true"
import script from "./JurisdictionManagementIcon.vue?vue&type=script&lang=ts"
export * from "./JurisdictionManagementIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__